// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modify-success[data-v-d3930b4e]{margin:80px 0;font-size:24px;color:#333;line-height:33px;text-align:center}", ""]);
// Exports
module.exports = exports;
